import { RouterStateSnapshot, Params } from '@angular/router';
import { RouterStateSerializer } from '@ngrx/router-store';

/**
 * The RouterStateSerializer takes the current RouterStateSnapshot
 * and returns any pertinent information needed. The snapshot contains
 * all information about the state of the router at the given point in time.
 * The entire snapshot is complex and not always needed. In this case, you only
 * need the URL and query parameters from the snapshot in the store. Other items could be
 * returned such as route parameters and static route data.
 */

export interface RouterStateUrl {
    url: string;
    params: Params;
    queryParams: Params;
}

export class CustomRouterStateSerializer implements RouterStateSerializer<RouterStateUrl> {
    /**
     *
     * @param routerState
     */

    /**
     *
     * @param routerState
     */
    serialize(routerState: RouterStateSnapshot): RouterStateUrl {
        let route = routerState.root;

        while (route.firstChild) {
            route = route.firstChild;
        }

        const {
            url,
            root: { queryParams },
        } = routerState;
        const { params } = route;

        // Only return an object including the URL, params and query params
        // instead of the entire snapshot
        return { url, params, queryParams };
    }
}

export const getRouteName = (url: string) => {
    try {
        const urlObj = new URL(url);
        const pathSegments = urlObj.pathname.split('/').filter((segment) => segment);
        return pathSegments.length > 0 ? pathSegments[pathSegments.length - 1] : null;
    } catch (error) {
        console.error('Invalid URL', error);
        return null;
    }
};

export const calculateStageProgress = (
    elapsedTime: number,
    stageDuration: number,
    startPercent: number,
    endPercent: number
): number => {
    const percentRange = endPercent - startPercent;
    const progress = Math.min(elapsedTime / stageDuration, 1) * percentRange;
    return startPercent + progress;
};

export const areFileArraysEqual = (prev: File[], curr: File[]): boolean => {
    if (prev === curr) {
        return true;
    }
    if (!prev || !curr || prev.length !== curr.length) {
        return false;
    }

    return prev.every((p, i) => {
        const c = curr[i];
        return p.name === c.name && p.size === c.size && p.lastModified === c.lastModified;
    });
};
